import { useContext, useState } from "react";
import { MapContainer, TileLayer, Marker} from 'react-leaflet';
import Sidebar from "./Sidebar";
import MapComponent from "./MapComponent";
import { useLocation } from "react-router";
import _ from "lodash";
import { tourDistance } from "../utils/utils.";
import { State, StateContext } from "../state";
import classNames from "classnames";


const GOOGLE_API_KEY = "AIzaSyBO54Bh-9_1QrcAcQMMa13DX3NMN3Q7la4";

export const TourMap = ({tours, me}: any) => {
  const location = useLocation()
  const { myPos } = useContext(StateContext) as State;
  const [selectedMarker, setSelectedMarker] = useState<any>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleMarkerClick = (marker: any) => {
    setSelectedMarker(marker);
    setIsSidebarOpen(true);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
    setSelectedMarker(null);
  };

  const selectedTour = location?.state?.selectedMarker;
  const firstTour = location?.state?.firstTour;

  let _tours = [...tours]
  if(myPos) {
    let pos = myPos
    if(firstTour) {
      pos = firstTour.routes[0].track
      pos = {latitude: pos[0], longitude: pos[1]}
    }
    if(selectedTour) {
      pos = selectedTour.route.track
      pos = {latitude: pos[0], longitude: pos[1]}
    }
    _tours.forEach((t: any) => {
      t.distance = tourDistance(t.routes[0].track, [pos.latitude, pos.longitude])
    })
    _tours = _.sortBy(tours, 'distance')
  }

  const mobile = window.innerWidth <= 600;

  return (
    <div className={classNames("relative", mobile ? 'col-reverse': 'row')}>
      {tours.length > 0 &&
        <MapComponent
          selected={selectedTour}
          tours={_tours}
          me={me}
          onMarkerClick={handleMarkerClick}
        />
      }
      {/* <Sidebar
        route={selectedMarker ? selectedMarker.route: selectedMarker}
        tour={selectedMarker ? selectedMarker.tour: selectedMarker}
        onClose={handleCloseSidebar}
        isOpen={isSidebarOpen}
      /> */}
    </div>
  );
}